"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildStore = buildStore;
const cookie_store_1 = require("./cookie-store");
const local_store_1 = require("./local-store");
function buildStore(config) {
    if (config.type == 'localStorage') {
        return new local_store_1.LocalStore(config.key);
    }
    if (config.type == 'cookie') {
        return new cookie_store_1.CookieStore(config.key);
    }
    throw new Error('Unknown store type');
}
//# sourceMappingURL=store.js.map